import { nuclearn_api_url } from "src/App";
import { authorizedUser } from "src/helpers/Auth";

/**
 * Download a report artifact with auth headers (bare <a href> links to the
 * artifact endpoint fail — the request carries no Authorization header).
 * Same blob pattern as FileDownload.tsx.
 */
export const downloadReportArtifact = async (
  artifactId: number,
  filename = `50_59_report_${artifactId}.docx`,
): Promise<boolean> => {
  try {
    const response = await fetch(
      `${nuclearn_api_url}/artifacts/${artifactId}/download`,
      {
        method: "GET",
        headers: {
          ...(authorizedUser().Authorization
            ? { Authorization: authorizedUser().Authorization as string }
            : {}),
        },
      },
    );
    if (!response.ok) {
      console.error("Report download failed:", response.status);
      return false;
    }
    // Prefer the server-provided filename when present.
    const disposition = response.headers.get("Content-Disposition");
    const match = disposition?.match(/filename="?([^";]+)"?/);
    const effectiveName = match?.[1] ?? filename;

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = effectiveName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
    return true;
  } catch (error) {
    console.error("Report download error:", error);
    return false;
  }
};
